// removed by extract-text-webpack-plugin
module.exports = {"sidebarOverlay":"_1bdtusgymz_WO6a8vMjSfJ","sidebar":"_2GnQho5JzL-2empqSHqSga","sidebarContent":"_32ZX1SMjcQJG_tMW8FrT44"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/02-organisms/global/sidebar.scss
// module id = 120
// module chunks = 0